import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import remove_from_symmetry_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/remove_from_symmetry.svg';
import { img } from '@phi/components';
import { uid_make_edges_symmetric_with_spinner } from '@frontend/ui_display';
import RemoveSymmetryTooltip from './RemoveSymmetryTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const RemoveSymmmetryIcon = remove_from_symmetry_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Remove edges from symmetry set';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || !this.state.symmetry_plane_selected
                || !this.selected_edges_or_faces;
        },

        selected_edges_or_faces() {
            return this.state.selected_edges_count > 0
                || this.state.selected_faces_count > 0;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uid_make_edges_symmetric_with_spinner(true, true);
        },
    },

    render() {
        return h(BarButton, {
            id: 'remove-from-symmetry-button',
            onClick: this.onClick,
            disabled: this.disabled,
            active: false,
            selected: this.state.tut_stage === 9,
            tippy: 'bottom',
            help: 'remove_from_symmetry_sets',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(remove_from_symmetry_svg, this.alt),
            tooltip: RemoveSymmetryTooltip,
        });
    },
});
